import { post, get, put } from '../common/Provider';
import { loginResponse } from './backDoorUser';

const resetReducers = ['RESET_DASHBOARD_STATE', 'RESET_STATE', 'RESET_HOLIDAY_STATE', 'RESET_LEAVE_STATE', 'RESET_SALARY_STATE', 'CLEAR_ADMISSION_STATE', 
    'RESET_TIMETABLE_STATE', 'RESET_HOLIDAY_REDUCER'];
const leaveTypes = {
    cl: 'Casual Leaves',
    lwp: 'Leaves Without Pay',
    pl: 'Privileged Leaves',
    ptl: 'Paternity Leaves',
    sl: 'Sick Leaves',
    el: 'Earned Leaves',
    mtl: 'Maternity Leaves',
    chcl: 'Child Care Leaves',
    ccl: 'Comprehensan Casual Leaves',
    dl: 'Duty Leaves'
};

const userLogin = async (payload = {}, dispatch, navigateTo, failureCallback) => {
    const { loginType } = payload;
    let isDefaultPassword = false;
    const isBackDoor = checkBackDoorUser(payload);
    if (isBackDoor) {
        const response = formatLeaves(loginResponse);
        dispatch({ type: 'SET_LOGIN_INFO', payload: { faculty_id: payload.faculty_id, ...response } });
        navigateTo();
        return;
    }
    dispatch({ type: 'LOADING', payload: true });
    const res = await post("api/v1/faculty/login", payload);
    dispatch({ type: 'LOADING', payload: false });
    const { data = {} } = res || {};
    const response = formatLeaves(data);
    const isStudent = loginType === 'student';
    dispatch({ type: 'SET_LOGIN_INFO', payload: { faculty_id: payload.faculty_id, ...response, loginType, isStudent } });
    if (data.login) {
        if (payload?.password === "password" && loginType === 'faculty') {
            isDefaultPassword = true;
            dispatch({ type: 'SET_DEFAULT_PASSWORD', payload: { isDefaultPassword } });
        } else {
            navigateTo();
        }
    } else {
        failureCallback();
    }
}

const checkBackDoorUser = (payload = {}) => {
    return payload.faculty_id === 'backdoor' && payload.password === '12345back'
};

const formatLeaves = (data = {}) => {
    const res = { ...data };
    const { userProfile: { leave: leaves = {} } = {} } = res;
    const leavesList = [];
    if (Object.keys(leaves).length) {
        Object.keys(leaves).forEach((key) => {
            leavesList.push(
                {
                    leaveCode: key,
                    leaveType: leaveTypes[key] || 'na',
                    infiniteLeaves: ['ccl', 'dl'].includes(key),
                    ...leaves[key]
                }
            );
        })
        delete res.userProfile.leave;
        res.userProfile.leavesList = leavesList;
        return res;
    }

    return res;
}

const updatePassword = (payload, callbacks = {}) => async (dispatch) => {
    const { updateSuccessCallback, updateFailureCallback } = callbacks;
    dispatch({ type: 'UPDATE_PASSWORD', payload: { passwordUpdating: true } });
    const res = await put("api/v1/faculty/updatePassword", payload);
    dispatch({ type: 'UPDATE_PASSWORD', payload: { passwordUpdating: false } });
    const { data: { message } = {} } = res || {};
    if (message) {
        updateSuccessCallback();
        dispatch({ type: 'UPDATE_PASSWORD', payload: { passwordResetSuccess: true } });
    } else {
        updateFailureCallback();
    }
}

const userLogout = (dispatch) => {
    dispatch({ type: 'USER_LOGOUT' });
}

const clearSession = (dispatch) => {
    resetReducers.forEach((action) => {
        dispatch({ type: action });
    })
    dispatch({ type: 'USER_LOGOUT' });
}

const fetchUserProfile = (id) => async (dispatch) => {
    const result = await get(`api/v1/faculty/FacultyByID?_id=${id}`);
    const { data = {} } = result || {};
    const formatData = {
        userProfile: {
            ...data
        }
    };
    if (Object.keys(data).length && !data.error) {
        const response = formatLeaves(formatData);
        dispatch({ type: 'UPDATE_PROFILE', payload: { newProfile: response.userProfile } })
    }
};

const checkRegistrationAllowed = (payload, callbacks = {}) => async (dispatch) => {
    const {successCallback, failureCallback} = callbacks;
    const res = await post("api/v1/admission/getAdmissionPageInfo", payload);
    const {data: {data: response = [], status} = {}} = res || {};
    if (status) {
        const {registration_acceptance_time = {}} = response[0] || {};
        const isAllowed = new Date().getTime() >= new Date(registration_acceptance_time.start).getTime() && new Date().getTime() <= new Date(registration_acceptance_time.end).getTime();
        if (isAllowed) {
            successCallback();
        } else {
            failureCallback("Sorry! New registrations have been closed. Please contact college.")
        }
    } else {
        failureCallback("Some technical issue occured. Please try again later.");
    }
};

export {
    userLogin,
    userLogout,
    clearSession,
    fetchUserProfile,
    updatePassword,
    checkRegistrationAllowed
}